import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-country-list',
    templateUrl: './country-list.component.html',
    styleUrls: ['./country-list.component.css'],
    standalone: false
})
export class CountryListComponent implements OnInit {
  @Input() region?: string;
  @Input() country?: string;

  constructor() { }

  ngOnInit() {
  }

}